import http from "@/settings/apiSettings";

class ValoriParametriSalarizareCustomDataService {

  GetValoriParametriSalarizareAngajat(empId: string, luna: number, anul: number): Promise<any> {
    return http.clientResurseUmane.get("/Salarizare/GetValoriParametriSalarizareAngajat", {
      params: { empId, luna, anul }
    });
  }

  // Valorile de companie sunt stabilite pe lună și se aplică tuturor angajaților
  // (SAL_IntroduceriDefaults), deci nu primesc un angajat.
  GetValoriParametriSalarizareCompanie(luna: number, anul: number): Promise<any> {
    return http.clientResurseUmane.get("/Salarizare/GetValoriParametriSalarizareCompanie", {
      params: { luna, anul }
    });
  }

  // „Valori implicite" — inputuri tip 'A' cu valorile default de companie (SAL_IntroduceriDefaults).
  GetValoriParametriSalarizareImplicite(luna: number, anul: number): Promise<any> {
    return http.clientResurseUmane.get("/Salarizare/GetValoriParametriSalarizareImplicite", {
      params: { luna, anul }
    });
  }

  // Autosalvare valoare (ca legacy SAL_IntroduceriUpdate). mode: Angajati | Companie | Valori implicite.
  SaveIntroducere(payload: {
    Mode: string; EmpId?: string | null; Cod: string; Valoare: number | null; Luna: number; Anul: number;
  }): Promise<any> {
    return http.clientResurseUmane.post("/Salarizare/SaveIntroducere", payload);
  }
}

export default new ValoriParametriSalarizareCustomDataService();
